import { isNumber } from 'lodash';
import moment from 'moment';

/**
 * Returns date of the day that was given days ago
 * @param {number} [days]
 * @param {string} [format]
 * @returns {string}
 */
export function dateDaysAgo(days = 0, format = 'YYYY-MM-DD'): string {
  if (days < 1) {
    return '';
  }

  return moment().subtract(days, 'days').format(format);
}

/**
 * Creates date from incomplete data
 * @param {Number|null} [year]
 * @param {Number|null} [month]
 * @param {Number|null} [day]
 * @returns {Date}
 */
export function createDate(
  year: number | null | undefined,
  month: number | null | undefined,
  day?: null | number | undefined
): Date {
  const today = new Date();
  const y = isNumber(year) ? year : today.getFullYear();
  const m = isNumber(month) ? month : today.getMonth() + 1;
  const d = isNumber(day) ? day : 1;

  return new Date(y, m, d);
}
